export default class Theme {
  constructor(className) {
    this.el = document.querySelector(className);
    this.switchables = document.querySelectorAll("[data-theme-switch]");
  }
  
  isLight() {
    return this.el.classList.contains("u-theme-light");
  }

  switchTheme() {
    this.el.classList.toggle("u-theme-light");
    this.switchables.forEach((el) => el.classList.toggle("-theme-light"));
    const event = new CustomEvent("themeswitch", {
      detail: {
        color: this.isLight() ? "black" : "white",
        theme: this.isLight() ? "white" : "black",
      },
    });
    document.dispatchEvent(event);
  }
}
